// @ts-nocheck
import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { find } from 'lodash'
import Field from '../../fields'
import { FormInput } from '../../../LEGACY/elemental'
import { FormFieldLayout } from '../../generic'
import Select from 'react-select'

export default class GPForm extends React.Component {
  state = {
    isSelectingGP: false,
  }

  getSelectOption = (gp) => {
    const label = gp.gpSurgeryName
      ? `${gp.gpName}, ${gp.gpSurgeryName}`
      : gp.gpName

    return {
      name: gp.gpName,
      surgery: gp.gpSurgeryName,
      label,
    }
  }

  onSelectGP = ({ name, surgery }) => {
    const { gps, onChange } = this.props
    const gp = find(gps, {
      gpName: name,
      gpSurgeryName: surgery,
    })

    Object.keys(gp).forEach((key) => {
      onChange({ key, value: gp[key] })
    })
  }

  toggleSelectGP = () => {
    this.setState((prevState) => ({
      isSelectingGP: !prevState.isSelectingGP,
    }))
  }

  renderGPName = () => {
    const { fields, gps, onChange } = this.props
    return (
      <div>
        <FormInput
          onChange={(e) =>
            onChange({
              key: 'gpName',
              value: e.target.value,
            })
          }
          value={fields.gpName || ''}
        />
        {gps && gps.length ? (
          <a
            className="toggle-gp-select"
            onClick={this.toggleSelectGP}
            style={styles.link}
          >
            Choose GP from list{' '}
            <span className="octicon octicon-chevron-right" />
          </a>
        ) : null}
      </div>
    )
  }

  renderGPSelect = () => {
    const { fields, gps } = this.props
    const options = gps.map(this.getSelectOption)
    return (
      <div>
        <Select
          classNamePrefix="lmc-select"
          getOptionValue={({ name }) => name}
          onChange={this.onSelectGP}
          options={options}
          value={find(options, {
            name: fields.gpName,
            surgery: fields.gpSurgeryName,
          })}
        />
        <a
          className="toggle-gp-select"
          onClick={this.toggleSelectGP}
          style={styles.link}
        >
          Type GP name manually{' '}
          <span className="octicon octicon-chevron-right" />
        </a>
      </div>
    )
  }

  render() {
    const { fields, formId, style } = this.props

    const { isSelectingGP } = this.state

    return (
      <div style={style}>
        <div style={styles.title}>GP</div>
        <div style={styles.formField}>
          <FormFieldLayout isNestedField label="Doctor name">
            {isSelectingGP ? this.renderGPSelect() : this.renderGPName()}
          </FormFieldLayout>
        </div>
        <div style={styles.formField}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="surgery-name-field"
            isNestedField
            keys="gpSurgeryName"
            label="Surgery / Practice name"
            formId={formId}
            type="text"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={styles.formField}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="gp-email-field"
            isNestedField
            inputType="email"
            keys="gpEmail"
            label="Email"
            formId={formId}
            type="text"
            validationTypes="email"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={styles.formField}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="address-field"
            isNestedField
            keys="gpAddress"
            label="Address"
            formId={formId}
            type="address"
            values={fields}
          />
          </Suspense>
        </div>
        <div style={styles.formField}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="gp-number-field"
            isNestedField
            keys="gpTelephone"
            label="Telephone"
            formId={formId}
            options={{
              phone: true,
              phoneRegionCode: 'GB',
            }}
            type="formattedText"
            values={fields}
          />
          </Suspense>
        </div>
      </div>
    )
  }
}

const styles = {
  formField: {
    paddingTop: 20,
  },
  link: {
    display: 'inline-block',
    marginTop: 5,
    float: 'right',
    textDecoration: 'none',
  },
  title: {
    fontWeight: 'bold',
    fontSize: 18,
  },
}

GPForm.propTypes = {
  fields: PropTypes.object.isRequired,
  formId: PropTypes.string.isRequired,
  gps: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
}
